import { gql } from '@apollo/client'

export default gql`
    mutation createInspectionZipDownloadOrderDetails($id: String!) {
        createZipDownloadOrderDetails: createSaleOrderInspectionDownload(
            id: $id
        ) {
            url
        }
    }
`
